import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import dayjs from 'dayjs';

import UserDataCell from './UserDataCell';

import { MediaBreakpoints } from 'hooks/Screen/useScreenSize';
import LinkCell from 'components/TrapsTables/Cells/LinkCell/LinkCell';
import { Vulnerability } from 'api/vulnerabilities/type';

interface ObjectVulsExpandableProps {
  data: Vulnerability;
  slug?: string;
}
const ObjectVulsExpandable: React.FC<ObjectVulsExpandableProps> = ({ data, slug }) => {
  const { t } = useTranslation();
  const mobile = useMediaQuery(MediaBreakpoints.mobile);
  const tablet = useMediaQuery(MediaBreakpoints.tablet);
  const desktop = useMediaQuery(MediaBreakpoints.desktop);

  return (
    <div className="d-flex w-100 flex-column">
      {mobile && (
        <>
          <div className="d-flex flex-column my-2  mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('TrapTables.InteractiveMap')}</span>
              <div>
                <LinkCell
                  title={data.floor_plan_name}
                  link={`/object/plan/vulnerability/${slug}/${data.floor_plan_slug}/${data.id}`}
                  icon="ri-treasure-map-line"
                />
              </div>
            </div>
          </div>
          <div className="d-flex flex-column my-2  mx-3">
            <div>
              <span className="me-1 fs-14 fw-bold">{t('ObjectVuls.table.criticality')}</span>
            </div>
            <div>{t(`ObjectVuls.criticality.${data.criticality}`, { defaultValue: data.criticality })}</div>
          </div>
        </>
      )}

      {tablet && (
        <>
          <div className="d-flex flex-wrap gap-2 justify-content-between my-2 mx-3">
            <div>
              <div>
                <span className="me-1 fs-14 fw-bold">{t('ObjectVuls.table.category')}</span>
              </div>
              <div>{t(`ObjectVuls.categories.${data.category}`, { defaultValue: data.category })}</div>
            </div>

            <div>
              <div>
                <span className="me-1 fs-14 fw-bold">{t('ObjectVuls.table.createDate')}</span>
              </div>
              <div>{dayjs(data.create_date).format('DD-MM-YYYY')}</div>
            </div>
          </div>
        </>
      )}

      {desktop && (
        <>
          <div className="d-flex flex-wrap gap-2 justify-content-between my-2 mx-3">
            <div>
              <div>
                <span className="me-1 fs-14 fw-bold">{t('ObjectVuls.table.instpector')}</span>
              </div>
              <div>
                <UserDataCell user={data.inspector_data} />
              </div>
            </div>

            <div>
              <div>
                <span className="me-1 fs-14 fw-bold">{t('ObjectVuls.table.responsible')}</span>
              </div>
              <div>{data.responsible_data.name}</div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ObjectVulsExpandable;
